/** Settlement screen rules (SELL-07, MERCH-58). Pure: no I/O. */

/**
 * How one line's order settles: every non-reversed line of the same order (sale,
 * commission, fees, GST, TCS…) and what is left. A line with no order is its own breakdown.
 * → { rows: [{ id, type, label, amount_paise }], net_paise }
 */
export function orderBreakdown(lines, line) {
  const same = line.order_id ? (lines || []).filter((l) => l.order_id === line.order_id && l.state !== 'reversed') : [line];
  const rows = same.map((l) => ({ id: l.id, type: l.type, label: l.label, amount_paise: l.amount_paise }));
  return { rows, net_paise: rows.reduce((a, r) => a + Number(r.amount_paise || 0), 0) };
}
